<mat-card class="content-card" style="padding-top: 15px; padding-bottom: 0; margin-top: 0; border-top-left-radius: 0; border-top-right-radius: 0;">

  <div>
  <div fxLayout="column" fxFlex="50">
    <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">


      <mat-form-field class="country-filter-field">
        <mat-select [formControl]="countriesSelect" placeholder="Country" (selectionChange)="onCountryChange()" [(ngModel)]="table.filters.countriesFilter" multiple>
          <mat-option *ngFor="let country of countries" [value]="country.isoCode">{{ country.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="identstatus-filter-field">
        <mat-select [formControl]="webIdStatusSelect" placeholder="Ident Status" (selectionChange)="onWebStatusChange()" [(ngModel)]="table.filters.identStatusFilter" multiple>
          <mat-option *ngFor="let webId of webIdStatus | enumToArray" [value]="webId.index">{{ webId.name | titlecase }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="!currentUserIsIssuerExternal()">
        <mat-form-field class="brand-filter-field" *ngIf="!currentUserIsPartner()">
          <mat-select [formControl]="companySelect" placeholder="Brand filters" (selectionChange)="onCompanyChange()" [(ngModel)]="table.filters.companiesFilter" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>


        <!-- #region star-end data, date filters, search -->



        <!-- #endregion star-end data, date filters, search -->


        <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
          <mat-form-field style="width: 400px;" class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="table.filters.str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </div>




    <div fxLayout="column" fxFlex="50">

      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-end center">
        <a  *appHasRoles="['admin', 'partner']" color="blue" mat-raised-button routerLink="/cards/card-infos/next-annual-fees">
          <span>Next annual fees</span>
        </a>

        <!--
        <a *appHasRoles="['admin', 'partner']" color="blue" mat-raised-button routerLink="/cards/card-infos/next-card-expiries">
          <span>Next expiries</span>
        </a>-->

        <button *appHasRoles="['admin']" mat-raised-button color="blue" (click)="cardsExpiringSoonFile()">Expire CSV</button>

        <a *appHasRoles="['admin', 'partner']" color="blue" mat-raised-button routerLink="/cards/card-infos/last-card-activities">
          <span>Last activities</span>
        </a>

      </div>
    </div>

  </div>

  <app-mat-table-generator #table
                           tableName = "customerOverviewTable"
                           [useEmbededFilter]="false"
                           [columns] ="columns"
                           [dataSource] ="dataSource"
                           [viewLink]="getViewLink"
                           [deleteEnabled]="deleteEnabled()"
                           [multiselectEnabled]="deleteEnabled()"
                           [saveFilters]="true"
  >
  </app-mat-table-generator>
</mat-card>
